import { Select } from "antd";
const onSearch = (value) => {};
const darkSelectClass =
  "dark:[&_.ant-select-selector]:bg-gray-800 \
   dark:[&_.ant-select-selector]:border-gray-700 \
   dark:[&_.ant-select-selector]:text-gray-100 \
   dark:[&_.ant-select-arrow]:text-gray-300 \
   dark:[&_.ant-select-clear]:text-gray-300";

const SelectInput = ({ emloyeeList, onChange, selectedEmployee }) => (
  <Select
   className={`w-full ${darkSelectClass}`}
    size="large"
    showSearch
    placeholder="Select a person"
    value={selectedEmployee || undefined}
    optionFilterProp="label"
    onChange={onChange}
    onSearch={onSearch}
    options={[
      { value: "All", label: "All" },
      ...emloyeeList.map((employee) => ({
        value: employee.ID,
        label: employee.NAME,
      })),
    ]}
  />
);

const SelectDepart = ({
  departList,
  onChange,
  selectedDepartment,
  allLabel,
}) => (
  <Select
    className={`w-full  ${darkSelectClass}`}
    size="large"
    showSearch
    placeholder="Select Department"
    value={selectedDepartment || undefined}
    optionFilterProp="label"
    notFoundContent="No departments found"
    onChange={onChange}
    onSearch={onSearch}
    options={[
      (allLabel ? [allLabel] : []),
      // { value: 'All', label: 'All' },
      ...departList?.map((dept) => ({
        value: dept.CODE,
        label: dept.DEPT,
      })),
    ]}
  />
);

const SelectEmployee = ({
  employeeList,
  onChange,
  selectedEmployee,
  customStyle,
  allLabel,
  mode,
  allowClear
}) => (
  <Select
  className={`w-full ${customStyle} ${darkSelectClass}`}
    size="large"
    showSearch
    placeholder="Select a person"
    value={selectedEmployee || undefined}
    optionFilterProp="label"
    onChange={onChange}
    notFoundContent="No employees found"
    onSearch={onSearch}
    options={[
      // ...(allLabel ? [{ value: '', label: allLabel }] : []),
      (allLabel ? [allLabel] : []),
      ...employeeList?.map((emp) => ({
        value: emp.ID,
        label: emp.NAME,
      })),
    ]}
    mode={mode || null}
    allowClear
  />
);



export { SelectInput, SelectDepart, SelectEmployee };
